<template>
  <div id="updateHeight" v-if="model">
    <mu-card-header :title="title" :subTitle="subTitle"></mu-card-header>
    <form @submit.prevent="updateHeightSettings">
      <div v-if="!model.cm">
        <mu-row>
          <mu-col width="100" tablet="50" desktop="50">
            <mu-row>
              <mu-col width="50" desktop="50" tablet="50">
                <mu-text-field
                  v-validate="'required|min_value:0|max_value:8'"
                  data-vv-value-path="inputValue"
                  data-vv-name="height_ft"
                  data-vv-as="ft"
                  :errorText="errors.first('height_ft')"
                  v-model.number="model.ft"
                  :min="0"
                  :max="8"
                  :hintText="$t('message.placeholderText')"
                  label="ft"
                  fullWidth
                ></mu-text-field>
              </mu-col>
              <mu-col width="50" desktop="50" tablet="50">
                <mu-text-field
                  v-model.number="model.in"
                  v-validate="'required|min_value:0|max_value:11'"
                  data-vv-value-path="inputValue"
                  data-vv-name="height_in"
                  data-vv-as="in"
                  :errorText="errors.first('height_in')"
                  :min="0"
                  :max="11"
                  :hintText="$t('message.placeholderText')"
                  label="in"
                  fullWidth
                ></mu-text-field>
              </mu-col>
            </mu-row>
          </mu-col>
        </mu-row>
      </div>
      <div v-if="model.cm">
        <mu-text-field
          v-model.number="model.cm"
          v-validate="'required|min_value:50|max_value:251'"
          data-vv-name="height_cm"
          data-vv-value-path="inputValue"
          data-vv-as="cm"
          :min="0"
          :max="251"
          :errorText="errors.first('height_cm')"
          :hintText="$t('message.placeholderText')"
          label="cm"
        ></mu-text-field>
      </div>
      <button type="submit" style="display: none;"></button>
      <mu-raised-button
        type="button"
        @click.native="updateHeightSettings"
        :disabled="isSaving"
        :label="isSaving ? $t('message.savingText') : $t('message.updateText')"
        secondary
      ></mu-raised-button>
    </form>
  </div>
</template>
<script>
  import SettingsApi from '../../../api/Settings';
  
  import MuTextField from "muse-ui/src/textField/textField";
  import MuRaisedButton from "muse-ui/src/raisedButton/raisedButton";

  export default {
    components: {
      MuRaisedButton,
      MuTextField
    },
    name: "update-height",
    data() {
      return {
        title: this.$t('message.heightUpdateFormTitle'),
        subTitle: this.$t('message.heightUpdateFormSubTitle'),
        isSaving: false,
        model: null,
      }
    },
    mounted() {
      let self = this;
      self.getHeightSettings();
    },
    methods: {
      getHeightSettings() {
        let self = this;
        SettingsApi.getHeightSettings().then(function (response) {
          self.model = response.data;
        })
      },
      updateHeightSettings() {
        let self = this;
        self.$validator.validateAll().then(function (valid) {
          if (valid === true) {
            self.isSaving = true;
            SettingsApi.updateHeightSettings(self.model)
              .then(function (response) {
                self.isSaving = false;
                self.$toastr.success(self.$t('message.labelSuccess'));
              })
          }
        });
      }
    }
  }
</script>
<style>
  #updateHeight {
    margin-bottom: 22px;
  }
  #updateHeight .mu-card-header {
    padding-left: 0;
  }
</style>



// WEBPACK FOOTER //
// Height.vue?54bd86be